import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../components/BarChart/BarChart';
import NoData from '../../../components/NoData/NoData';
import SectionTitle from '../../../components/SectionTitle/SectionTitle';
import SelectInput, { ValueOption } from '../../../components/SelectInput/SelectInput';
import { useStatistics } from '../../../hooks/useStatistics';

function MostEyeCatchingDressesPerYear() {

  const { t } = useTranslation();

  const [selectedYear, setSelectedYear] = useState<string>('');
  const statisticsData = useStatistics('total-year');
  const years = Object.keys(statisticsData).sort();

  const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedYear(event.target.value);
  };

  const yearOptions: ValueOption[] = years.map(year => ({
    value: year,
    readableValue: year,
  }));

  const dataRaw = selectedYear ? statisticsData[selectedYear] : {};
  const data: { [key: string]: number } = {};

  Object.entries(dataRaw).forEach(([dress, count]) => {
    const collection = dress.split('_')[0];
    if (!data[collection]) {
      data[collection] = 0;
    }
    data[collection] += count;
  });

  const xLabels = Object.keys(data);
  const dataSets = [
    {
      label: selectedYear,
      data: Object.values(data),
      backgroundColor: ['rgba(75, 192, 192, 0.5)'],
      borderColor: ['rgba(75, 192, 192, 1)'],
      borderWidth: 1,
    },
  ];

  return (
    <>
      <SectionTitle text={t("stats.dress_x_year")}/>
      {yearOptions.length > 0 ? (
        <>
          <SelectInput
            values={yearOptions}
            label="Select a year"
            onChange={handleYearChange}
            defaultValue={selectedYear}
          />
          <BarChart title={selectedYear} dataSets={dataSets} xLabels={xLabels} />
        </>
      ) : (
        <NoData message={t("global.empty_results")} />
      )}
    </>
  );
}

export default MostEyeCatchingDressesPerYear;
